import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [{
      path: "/",
      name: "home",
      redirect: "login"
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/login"),
      meta: {
        title: "登录"
      }
    },
    {
      path: "/getPassword",
      name: "getPassword",
      component: () => import("@/views/getPassword/index"),
      meta: {
        title: "查找密码"
      }
    },
    {
      path: "/MemberCenter",
      name: "MemberCenter",
      component: () => import("@/views/MemberCenter/Member"),
      meta: {
        title: "会员中心"
      }
    },
    {
      path: "/uploadAttachments",
      name: "uploadAttachments",
      component: () => import("@/views/MemberCenter/uploadAttachments"),
      meta: {
        title: "附件上传"
      }
    },
    {
      path: "/ChangePassword",
      name: "ChangePassword",
      component: () => import("@/views/MemberCenter/ChangePassword"),
      meta: {
        title: "修改密码"
      }
    },
    {
      path: "/MembershipCard",
      name: "MembershipCard",
      component: () => import("@/views/MemberCenter/MembershipCard"),
      meta: {
        title: "电子会员证"
      }
    },
    {
      path: "/stationMessage",
      name: "stationMessage",
      component: () => import("@/views/MemberCenter/stationMessage"),
      meta: {
        title: "站内信"
      }
    },
    {
      path: "/stationDetail",
      name: "stationDetail",
      component: () => import("@/views/MemberCenter/stationDetail"),
      meta: {
        title: "站内信详情"
      }
    },
    {
      path: "/PaymentList",
      name: "PaymentList",
      component: () => import("@/views/MemberCenter/PaymentList"),
      meta: {
        title: "缴费列表"
      }
    },
    {
      path: "/payMeeting",
      name: "payMeeting",
      component: () => import("@/views/MeetingCenter/meetingPay"),
      meta: {
        title: "会议缴费列表"
      }
    },
    {
      path: "/OfflinePayment",
      name: "OfflinePayment",
      component: () => import("@/views/MemberCenter/OfflinePayment"),
      meta: {
        title: "缴费列表"
      }
    },
    {
      path: "/createMemberOrder",
      name: "createMemberOrder",
      component: () => import("@/views/MemberCenter/createMemberOrder"),
      meta: {
        title: "缴费"
      }
    },
    {
      path: "/onlinePayment",
      name: "onlinePayment",
      component: () => import("@/views/MemberCenter/onlinePayment"),
      meta: {
        title: "线上缴费"
      }
    },
    {
      path: "/MeetingCenter",
      name: "MeetingCenter",
      component: () => import("@/views/MeetingCenter/Meeting.vue"),
      meta: {
        title: "会议中心"
      }
    },
    {
      path: "/memberStyleDetail",
      name: "memberStyleDetail",
      component: () => import("@/views/MemberCenter/memberStyleDetail.vue"),
      meta: {
        title: "会员风采详情"
      }
    },
    {
      path: "/memberStyle",
      name: "memberStyle",
      component: () => import("@/views/MemberCenter/memberStyle.vue"),
      meta: {
        title: "会员风采"
      }
    },
    {
      path: "/PaperList",
      name: "PaperList",
      component: () => import("@/views/MeetingCenter/PaperList.vue"),
      meta: {
        title: "会议论文列表"
      }
    },
    {
      path: "/hotelList",
      name: "hotelList",
      component: () => import("@/views/MeetingCenter/hotelList.vue"),
      meta: {
        title: "酒店列表"
      }
    },
    {
      path: "/hotel",
      name: "hotel",
      component: () => import("@/views/MeetingCenter/hotel.vue"),
      meta: {
        title: "酒店预定"
      }
    },
    {
      path: "/EnrolledMeeting",
      name: "EnrolledMeeting",
      component: () => import("@/views/MeetingCenter/EnrolledMeeting.vue"),
      meta: {
        title: "已报名会议"
      }
    },
    {
      path: "/signUp",
      name: "signUp",
      component: () => import("@/views/MeetingCenter/signUp.vue"),
      meta: {
        title: "立即报名"
      }
    },
    {
      path: "/MeetingDetails",
      name: "MeetingDetails",
      component: () => import("@/views/MeetingCenter/MeetingDetails.vue"),
      meta: {
        title: "会议详情"
      }
    },
    {
      path: "/register",
      name: "register",
      component: () => import("@/views/register/index.vue"),
      children: [{
          path: "/quick",
          name: "quick",
          component: () => import("@/views/register/quick.vue"),
          meta: {
            title: "快捷注册"
          }
        },
        {
          path: "/person",
          name: "personRegister",
          component: () => import("@/views/register/person/index.vue"),
          meta: {
            title: "个人会员注册"
          }
        },
        {
          path: "/group",
          name: "groupRegister",
          component: () => import("@/views/register/group/index.vue"),
          meta: {
            title: "团体会员注册"
          }
        }
      ]
    },
    {
      path: "/rule",
      name: "rule",
      component: () => import("@/views/rule"),
      meta: {
        title: "入会须知"
      }
    },
    {
      path: "/editMember",
      name: "editMember",
      component: () => import("@/views/register/editMember"),
      meta: {
        title: "基本资料"
      }
    },
  ]
});